<template>
      <div class="mx-auto content">
        您还未通过邮件确认或注册确认信已经过期，请点击下方按钮重新获取确认邮件。
        <div style="padding-left:10px" class="mt-4">
          <el-alert
            :title="this.res.data"
            type="success"
            center
            v-if="this.res.status">
          </el-alert>
          <el-alert
            :title="this.res.error"
            type="error"
            center
            v-if="this.res.error">
          </el-alert>
          <n-button type="primary" round class="w-100" size="lg" :disabled="butDisable" @click="submit()">重新发送确认信</n-button>
          <!-- <p class="text-center checkbox my-2">或</p>
          <n-button type="primary" round simple class="w-100 mb-3" @click="isShowLogin('login')">
            去登录
          </n-button> -->
        </div>
      </div>
</template>
<script>
import {
  Button,
  // Checkbox,
  // FormGroupInput,
} from '@/components';
import account from "@/module/user/user.service";

export default {
  name: 'signup-error',
  props:{
    data:{error:String,id:Number}
  },
  components: {
    [Button.name]: Button,
    // [Checkbox.name]: Checkbox,
    // [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      res:{status:false},
      butDisable:false
    }
  },
  methods:{
    isShowLogin(v){
        this.$emit('onchange',v)
    },
    
    submit() {
      this.butDisable=true
      account.sendverifymail(this.data.id).then(res=>{
        this.res = res;
        this.butDisable = res.status
      })
    },
  }
};
</script>
<style>
.signup-page .btn{
  margin: 0;
}
.signup-page .noaccount, .signup-page .checkbox{
  font-size: 14px;
  color:gray;
}
.signup-page .form-check{
  margin-bottom: 6px;
}
.signup-page .form-check .form-check-sign::before, .signup-page .form-check .form-check-sign::after{
  width: 18px;
  height:18px;
}
.signup-page .form-check .form-check-label{
  line-height: 18px;
  padding-left: 24px;
}
</style>
